import classes from './InputPrice.module.css';

const InputPrice = (props) => {
  const { attribute, classList = [] } = props;
  const className = `${classes.InputPrice} ${classList
    .map((item) => classes[item])
    .join(' ')}`;

  let value = attribute.value;

  if (!Number(value)) {
    value = 0;
  } else {
    value = attribute.value.toLocaleString('ko-KR');
  }

  return (
    <div className={className}>
      <input
        type='text'
        {...attribute}
        value={value}
        autoComplete='off'
        className={classes['InputPrice__Input']}
      />
      <div className={classes['InputPrice__Text']}>{value}</div>
    </div>
  );
};

export default InputPrice;
